import React from 'react';
import classNames from 'classnames';
import { HiOutlineArrowLeft } from 'react-icons/hi';

const SigfoxSeriesDeviceList = ({
  seriesDevices,
  onDeviceClick,
  notes,
  editingNote,
  onStartEditNote,
  onSaveNote,
  onCancelEditNote,
  loadingDevices,
  selectedSeries,
  onBackToSeries,
  isDark
}) => {
  return (
    <div className="mb-6">
      <div className="flex items-center mb-4">
        <button
          onClick={onBackToSeries}
          className={classNames(
            "flex items-center mr-4 px-3 py-2 rounded-lg transition-colors",
            isDark 
              ? "bg-gray-700 hover:bg-gray-600 text-gray-300" 
              : "bg-gray-200 hover:bg-gray-300 text-gray-700"
          )}
        >
          <HiOutlineArrowLeft className="w-4 h-4 mr-2" />
          戻る
        </button>
        <h2 className={classNames(
          "text-xl font-bold"
        )}>
          {selectedSeries.customerName} - {selectedSeries.seriesName}
        </h2>
      </div>

      {loadingDevices ? (
        <div className="flex justify-center items-center h-32">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className={classNames(
            "min-w-full rounded-lg overflow-hidden",
            isDark 
              ? "bg-gray-800 shadow-lg" 
              : "bg-white shadow-xl border border-gray-200"
          )}>
            <thead className={classNames(
              "text-left",
              isDark ? "bg-gray-700 text-gray-300" : "bg-blue-50 text-blue-900 border-b border-blue-200"
            )}>
              <tr>
                <th className="px-6 py-3 font-semibold">Custom ID</th>
                <th className="px-6 py-3 font-semibold">Device ID</th>
                <th className="px-6 py-3 font-semibold">Last Message</th>
                <th className="px-6 py-3 font-semibold">Seq</th>
                <th className="px-6 py-3 font-semibold">Data</th>
                <th className="px-6 py-3 font-semibold">Device Type</th>
                <th className="px-6 py-3 font-semibold">備考</th>
              </tr>
            </thead>
            <tbody className={classNames(
              "divide-y",
              isDark ? "divide-gray-700" : "divide-blue-100"
            )}>
              {seriesDevices.map((device, index) => (
                <tr 
                  key={device.customData} 
                  className={classNames(
                    "hover:bg-blue-50 dark:hover:bg-gray-700 transition-colors",
                    index % 2 === 0 
                      ? (isDark ? "bg-gray-800" : "bg-white") 
                      : (isDark ? "bg-gray-750" : "bg-blue-25")
                  )}
                >
                  <td 
                    className="px-6 py-4 font-medium text-gray-900 dark:text-gray-100 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-800 transition-colors"
                    onClick={() => onDeviceClick(device.customData)}
                  >
                    {device.customData}
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900 dark:text-gray-100">
                    {device.device || '-'}
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900 dark:text-gray-100">
                    {device.lastMessageTime ? new Date(device.lastMessageTime).toLocaleString('ja-JP') : '-'}
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900 dark:text-gray-100">
                    {device.seqNumber || '-'}
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900 dark:text-gray-100">
                    <div className="font-mono max-w-xs truncate" title={device.dataPayload || '-'}>
                      {device.dataPayload || '-'}
                    </div>
                  </td>
                  <td className="px-6 py-4 font-medium text-gray-900 dark:text-gray-100">
                    {device.deviceTypeId || '-'}
                  </td>
                  <td 
                    className="px-6 py-4 font-medium text-gray-900 dark:text-gray-100 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900 transition-colors"
                    onClick={(e) => {
                      if (editingNote !== device.customData) {
                        e.stopPropagation();
                        onStartEditNote(device.customData);
                      }
                    }}
                  >
                    {editingNote === device.customData ? (
                      <div className="flex items-center space-x-2">
                        <input
                          type="text"
                          defaultValue={notes[device.customData] || ''}
                          className={classNames(
                            "flex-1 px-2 py-1 text-sm border rounded",
                            isDark 
                              ? "bg-gray-700 border-gray-600 text-gray-100" 
                              : "bg-white border-gray-300 text-gray-900"
                          )}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              onSaveNote(device.customData, e.target.value);
                            } else if (e.key === 'Escape') {
                              onCancelEditNote();
                            }
                          }}
                          onBlur={(e) => onSaveNote(device.customData, e.target.value)}
                          autoFocus
                        />
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onSaveNote(device.customData, e.target.parentElement.querySelector('input').value);
                          }}
                          className={classNames(
                            "px-2 py-1 text-xs rounded",
                            isDark 
                              ? "bg-green-600 hover:bg-green-700 text-gray-100" 
                              : "bg-green-500 hover:bg-green-600 text-white"
                          )}
                        >
                          保存
                        </button>
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            onCancelEditNote();
                          }}
                          className={classNames(
                            "px-2 py-1 text-xs rounded",
                            isDark 
                              ? "bg-gray-600 hover:bg-gray-700 text-gray-100" 
                              : "bg-gray-500 hover:bg-gray-600 text-white"
                          )}
                        >
                          取消
                        </button>
                      </div>
                    ) : (
                      <div title="クリックして編集">
                        {(notes[device.customData] && notes[device.customData] !== 'クリックして備考を追加') ? notes[device.customData] : ''}
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SigfoxSeriesDeviceList; 